import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IJobDocumentTreeNodeViewModel } from '../shared/models/nola-job-document-models';


interface CaalFileDialogData {
    caption: string;
    hardwareItemId: number;
    selectedNodeData: IJobDocumentTreeNodeViewModel;
    isForExport: boolean;
    exportSettings: boolean;
    exportSettingsAllowed: boolean;
    exportSchedule: boolean;
    exportScheduleAllowed: boolean;
    exportAdvanced: boolean;
    exportAdvancedAllowed: boolean;
    exportFactory: boolean;
    exportFactoryAllowed: boolean;
}

@Component({
    selector: 'dl-template-name-dialog',
    template: `
        <popup-header text="{{ data.caption }}" (clickAction)="onCancelClick()"></popup-header>
        <div class="minsize">
            <cl-nola-job-document #tree [hardwareItemId]="data.hardwareItemId" [caalMode]="true" [multiSelect]="false" (selectionChanged)="onSelectionChanged($event)"></cl-nola-job-document>
            <span [hidden]="tree?.treeControl?.dataNodes?.length > 0">no documents available</span>
        </div>
        <div class="padding" [hidden]="!data.isForExport">
            <mat-checkbox class="margin" [(ngModel)]="data.exportSettings"
                        [hidden]="!data.exportSettingsAllowed">
                Settings
            </mat-checkbox>
            <mat-checkbox class="margin" [(ngModel)]="data.exportSchedule"
                        [hidden]="!data.exportScheduleAllowed">
                Schedule
            </mat-checkbox>
            <mat-checkbox class="margin" [(ngModel)]="data.exportAdvanced"
                        [hidden]="!data.exportAdvancedAllowed">
                Advanced
            </mat-checkbox>
            <mat-checkbox class="margin" [(ngModel)]="data.exportFactory"
                        [hidden]="!data.exportFactoryAllowed">
                Factory
            </mat-checkbox>
            <span [hidden]="data.exportSettingsAllowed || data.exportScheduleAllowed || data.exportAdvancedAllowed || data.exportFactoryAllowed" style="color:red">No available options for export</span>
        </div>
        <popup-button-container>
          <button mat-button (click)="onCancelClick()">CANCEL</button>
          <button mat-button [mat-dialog-close]="data" [disabled]="(data.selectedNodeData == null || data.selectedNodeData.isDirectory == true || data.selectedNodeData.isMissing == true) || (data.isForExport && !data.exportSettings && !data.exportSchedule && !data.exportAdvanced && !data.exportFactory)" >OK</button>
        </popup-button-container>
    `,
    styles: [
        `
        .minsize {
              min-width: 450px;
              min-height: 200px;
              padding: 20px;
            }
        .padding {
              padding: 20px;
            }
        .margin {
            margin: 20px;
            }
        `
    ]
})
export class CaalFileDialogComponent {
    public static $name: string = 'templateNameDialog';
    

    constructor(
        private dialogRef: MatDialogRef<CaalFileDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: CaalFileDialogData
    ) {
    }

    public onSelectionChanged(event: IJobDocumentTreeNodeViewModel) {
        this.data.selectedNodeData = event;
    }

    public onCancelClick() {
        

        this.data.selectedNodeData = null;
        this.dialogRef.close();
    }
}
